export default "__VITE_ASSET__BxnnH8yW__"